import {
    nl2br,
    maxLength,
    formatBool,
    formatName,
    formatInitials,
    formatNumber,
    formatMoney,
    formatMoneyNumber,
    formatPercent,
    formatTime,
    formatTimeDuration,
    formatDate,
    formatDateShort,
    formatDateFriendlyNoYear,
    formatDateTime,
    iconColor,
    iconName,
    fileNameMaxLength,
    fileColor,
    fileExtension,
    fileName,
    formatRecurrenceOnce,
    formatRecurrence,
    formatRecurrenceWorkflow,
    formatPeriodLabel,
    formatOverdue
} from "@/plugins/formatting";

export default {
    install(Vue) {
        Vue.filter("nl2br", nl2br);
        Vue.filter("max_len", maxLength);
        Vue.filter("format_name", formatName);
        Vue.filter("format_initials", formatInitials);
        Vue.filter("format_overdue", formatOverdue);

        Vue.filter("format_bool", formatBool);
        Vue.filter("format_number", formatNumber);
        Vue.filter("format_money_number", formatMoneyNumber);
        Vue.filter("format_money", formatMoney);
        Vue.filter("format_percent", formatPercent);

        Vue.filter("format_date", formatDate);
        Vue.filter("format_date_short", formatDateShort);
        Vue.filter("format_date_friendly_no_year", formatDateFriendlyNoYear);
        Vue.filter("format_datetime", formatDateTime);
        Vue.filter("format_time", formatTime);
        Vue.filter("format_time_duration", formatTimeDuration);

        Vue.filter("icon_color", iconColor);
        Vue.filter("icon_name", iconName);
        Vue.filter("file_name_max_len", fileNameMaxLength);
        Vue.filter("file_color", fileColor);
        Vue.filter("file_extension", fileExtension);
        Vue.filter("file_name", fileName);

        Vue.filter("format_recurrence", formatRecurrence);
        Vue.filter("format_recurrence_once", formatRecurrenceOnce);
        Vue.filter("format_recurrence_workflow", formatRecurrenceWorkflow);
        Vue.filter("format_period_label", formatPeriodLabel);
    }
};
